export class JointStyle {
    public static BEVEL: string = "bevel";
    public static MITER: string = "miter";
    public static ROUND: string = "round";
}
